import Meta from '@/components/meta'
import Header, { HeaderComponent } from '@/components/header.tsx'
import Footer from '@/components/footer.tsx'
import { ThemeProvider } from './theme-provider'

type PageWrapperProps = {
  children: any
  seo: any
  headerNav?: any
  headerBanners?: any
  footerNav?: any
  newsletterForm?: any
  bodyTw?: string
  breadcrumb?: any[]
  darkMode?: boolean
  canExperiment?: boolean
}

export default function PageWrapper({
  children,
  seo,
  headerNav = null,
  headerBanners = null,
  footerNav = null,
  newsletterForm = null,
  bodyTw = 'bg-transparent',
  breadcrumb = [],
  darkMode = false,
  canExperiment = false,
}: PageWrapperProps) {
  return (
    <ThemeProvider contentfulDarkModeSet={darkMode}>
      {!canExperiment ? (
        <HeaderComponent
          {...headerNav?.fields}
          id={headerNav?.sys?.id}
          headerBanners={headerBanners}
          newsletterForm={newsletterForm}
        />
      ) : (
        <Header
          {...headerNav?.fields}
          id={headerNav?.sys?.id}
          headerBanners={headerBanners}
          newsletterForm={newsletterForm}
        />
      )}
      <Meta seo={seo} breadcrumb={breadcrumb} />
      <main className={bodyTw}>{children}</main>
      <Footer
        footerNav={footerNav}
        newsletterForm={newsletterForm}
        showLinkSections={headerNav?.fields?.mainNavItems?.length > 0}
      />
    </ThemeProvider>
  )
}
